module.exports = __webpack_public_path__ + "static/media/change-direction.029a020e.svg";